/*
  SGVP Automatic Free Gifts
  Testing: Godhooli Toothpaste — Buy 5 Get 1

  This script adds or removes the matching gift.
  Shopify native discounts control the price.
*/

(() => {
  if (window.__sgvpGiftSyncInstalled) return;
  window.__sgvpGiftSyncInstalled = true;

  const rules = [
    {
      handle: "godhooli-balm-herbal-pain-relief-for-headache-muscle-and-joint",
      buy: 5
    },
    {
      handle: "godhooli-herbal-toothpaste-natural-oral-care-and-teeth-strength",
      buy: 5
    },
    {
      handle: "sg-koff-lozenges-herbal-relief-for-cough-and-sore-throat",
      buy: 10
    }
  ];

  const marker = "_automatic_free_gift";

  const root =
    (window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root) || "/";

  const endpoint = path =>
    root.replace(/\/$/, "") + "/" + path;

  async function api(path, payload) {
    const response = await fetch(endpoint(path), {
      method: payload === undefined ? "GET" : "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        ...(payload === undefined
          ? {}
          : { "Content-Type": "application/json" })
      },
      body:
        payload === undefined
          ? undefined
          : JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(
        "SGVP " + path + ": HTTP " + response.status
      );
    }

    return response.json();
  }

  const ready = Promise.all(
    rules.map(async rule => {
      const product = await api(
        "products/" + rule.handle + ".js"
      );

      rule.ids = new Set(
        product.variants.map(v => Number(v.id))
      );
    })
  );

  let pending = null;

  async function reconcile() {
    await ready;

    for (let attempt = 0; attempt < 12; attempt++) {
      const cart = await api("cart.js");
      let mutation = null;

      for (const rule of rules) {
        const paidByVariant = new Map();
        const gifts = [];

        for (const item of cart.items) {
          if (
            item.properties &&
            item.properties[marker] === rule.handle
          ) {
            gifts.push(item);
          } else if (
            rule.ids.has(Number(item.variant_id)) &&
            !(item.properties && item.properties[marker]) &&
            !item.selling_plan_allocation
          ) {
            const id = Number(item.variant_id);

            paidByVariant.set(
              id,
              (paidByVariant.get(id) || 0) +
                item.quantity
            );
          }
        }

        const eligible = [...paidByVariant.entries()]
          .filter(entry => entry[1] >= rule.buy)
          .sort((a, b) => b[1] - a[1]);

        const desiredId = eligible.length
          ? eligible[0][0]
          : null;

        const matching = gifts.find(
          item => Number(item.variant_id) === desiredId
        );

        const extra = gifts.find(
          item =>
            !desiredId ||
            item.key !== (matching && matching.key)
        );

        if (extra) {
          mutation = () =>
            api("cart/change.js", {
              id: extra.key,
              quantity: 0
            });
        } else if (
          matching &&
          matching.quantity !== 1
        ) {
          mutation = () =>
            api("cart/change.js", {
              id: matching.key,
              quantity: 1
            });
        } else if (desiredId && !matching) {
          mutation = () =>
            api("cart/add.js", {
              items: [
                {
                  id: desiredId,
                  quantity: 1,
                  properties: {
                    [marker]: rule.handle
                  }
                }
              ]
            });
        }

        if (mutation) break;
      }

      if (!mutation) return cart;

      await mutation();
    }

    throw new Error(
      "SGVP gift sync exceeded maximum cart changes"
    );
  }

  window.sgvpSyncGifts = async function () {
    if (pending) {
      await pending.catch(() => {});
    }

    const work = reconcile();
    pending = work;

    try {
      return await work;
    } catch (error) {
      console.error("SGVP free gift:", error);
      return api("cart.js");
    } finally {
      if (pending === work) {
        pending = null;
      }
    }
  };
})();
